<template>
	<b-container class="pg-instruction-cont">
		<img
			class="pg-img-pos"
			src="../../assets/newdesign/dashboard/games/wordle-haze.svg"
			alt=""
		/>
		<span class="pg-blue-txt d-flex w80">Wordle Game Instructions</span>
		<h2 class="mt-3 mb-2">Objective :</h2>
		<h3>Guess the 5-letter word within <b>6 tries</b>.</h3>
		<h2 class="mt-3 mb-2">How to Play :</h2>
		<main class="d-flex pl-1">
			<h4 class="mr-1">1.</h4>
			<section>
				<h4>Enter a Word :</h4>
				<h3>Type any 5-letter word and press Enter.</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">2.</h4>
			<section>
				<h4>Color Clues :</h4>
				<img
					class="my-2"
					src="../../assets/newdesign/dashboard/games/wordle-1.svg"
					alt=""
				/>
				<h3>
					<span class="pg-green-txt mr-1">Green :</span>The letter is in the
					correct position.
				</h3>
				<img
					class="my-2"
					src="../../assets/newdesign/dashboard/games/wordle-2.svg"
					alt=""
				/>
				<h3>
					<span class="pg-yellow-txt mr-1">Yellow:</span>The letter is in the
					word but in the wrong position.
				</h3>
				<img
					class="my-2"
					src="../../assets/newdesign/dashboard/games/wordle-3.svg"
					alt=""
				/>
				<h3>
					<span class="pg-grey-txt mr-1">Gray:</span>The letter is not in the
					word at all.
				</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">3.</h4>
			<section>
				<h4>Repeat :</h4>
				<h3>Use the color clues to make better guesses with each attempt.</h3>
			</section>
		</main>
		<main class="d-flex pl-1 mt-2">
			<h4 class="mr-1">4.</h4>
			<section>
				<h4>Game Over :</h4>
				<h3>
					The game ends when the board is full and no more moves are possible.
				</h3>
			</section>
		</main>
	</b-container>
</template>

<script>
export default {};
</script>

<style></style>
